import type { FaireProductEntity } from "../../entity_types/product";

export const p_9vz3jy64qm: FaireProductEntity = {
  token: "p_9vz3jy64qm",
  type: "product",
  name: "Anywhere Towel Reversible - RJW Lemon Sparkle",
  brandToken: "b_ci67w2i6k6",
  brandName: "Once Again Home Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/29f309dce32d6d1652f116f8cdd3daee2899ffdba6e549cbab0dbab136652e69.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/645c9ff704a584fd11608a9a61c32bf12e60e557c7d572798f8fd22f6a567744.jpeg",
    "https://cdn.faire.com/fastly/cac37e0a824e03f8da20bf15cd745dd91db6d206941dd6fc2eec9831bd5bfb45.jpeg",
  ],
  priceDollars: 13.29,
  description:
    'Style: Lemon freshness sashays across this vintage-inspired print. \n\n\nPerfect uses: Kitchen or Dish Drying Towel in your Kitchen, Hand Towel in your Bathroom, or Workout Towel.\n\n\nRecycled Impact: 3 bottles were Recycled in making this Towel.\n\n\nDimensions: Oversized 18"x30".\n\n\nReversible: Yes\n\nIncludes: Towel with Hanging Loop.\n\n\nMaterial: Made with Certified Recycled Post-consumer Materials. 80% Recycled Polyester, 20% Polyamide.\n\nCare: Machine Wash, No Bleach, No Fabric Softener, Tumble Dry.',
  tags: [],
  msrpDollars: 26.59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:10.797Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
